import { TenantConfig } from './tenant-config.model';
import { FeatureConfig } from './tenant-config.model';

/**
 * Configuración LOCAL hardcodeada para probar el patrón.
 *
 * Más adelante este objeto se reemplaza por una llamada HTTP a
 * `/api/config/current` SIN tocar componentes / directivas / templates.
 *
 * Para probar otro tenant durante el experimento, cambiar SOLO este archivo.
 */
export const LOCAL_TENANT_CONFIG: TenantConfig = {
    tenantId: 'tenant-acme',
    applicationId: 'webprestadores',
    version: 1,

    features: {
        'sideMenu.admissions': FeatureConfig.HIDDEN,
        'sideMenu.home': FeatureConfig.HIDDEN,
        'sideMenu.cases': FeatureConfig.ENABLED,
        'sideMenu.schedule': FeatureConfig.HIDDEN,
        'sideMenu.attentions': FeatureConfig.HIDDEN,
        'sideMenu.tasks': FeatureConfig.HIDDEN,
        'sideMenu.providers': FeatureConfig.HIDDEN,
        'sideMenu.consolidation': FeatureConfig.HIDDEN,
        'sideMenu.issues': FeatureConfig.HIDDEN,
        'sideMenu.dataManagement': FeatureConfig.HIDDEN,
        'sideMenu.provisionsControl': FeatureConfig.HIDDEN,
        'headerChips.help': FeatureConfig.DISABLED,
        'headerChips.userMenu': FeatureConfig.ENABLED,
        'caseData.edit': FeatureConfig.HIDDEN,
        'caseData.editVisibility': FeatureConfig.HIDDEN,
        'caseData.diagnosesBtn': FeatureConfig.HIDDEN,
        'caseData.arrangementsBtn': FeatureConfig.HIDDEN,
        'caseData.footerActions': FeatureConfig.HIDDEN,
        'caseData.tracking': FeatureConfig.HIDDEN,
        'caseData.patientData.actions': FeatureConfig.HIDDEN,
        'caseData.exportActions': FeatureConfig.HIDDEN,
        'caseData.arrangementInfo': FeatureConfig.HIDDEN,
        'provisionsDetail.addProvision': FeatureConfig.HIDDEN,
        'provisionsDetail.provisionActions': FeatureConfig.HIDDEN,
        'provisionsDetail.statusBtn': FeatureConfig.DISABLED,
        'provisionsDetail.tableActions': FeatureConfig.HIDDEN,
        'provisionsDetail.addAgreement': FeatureConfig.HIDDEN,
        'provisionsDetail.agreementActions': FeatureConfig.HIDDEN,
        'provisionScheme.billingBtn': FeatureConfig.HIDDEN,
        'evolutionComponent.setVisibility': FeatureConfig.HIDDEN,
        'evolutionComponent.addTask': FeatureConfig.HIDDEN,
        'scheduleCase.replaceAgreementBtn': FeatureConfig.HIDDEN,
        'scheduleCase.statusSelector': FeatureConfig.DISABLED,
        'supplyList.addSupplyBtn': FeatureConfig.HIDDEN,
        'supplyList.supplyActionsBtn': FeatureConfig.ENABLED,
        'supplyList.supplyActions.update': FeatureConfig.HIDDEN,
        'supplyList.supplyActions.modify': FeatureConfig.HIDDEN,
        'supplyList.supplyActions.loadPrice': FeatureConfig.ENABLED,
        'supplyList.supplyActions.addPrice': FeatureConfig.ENABLED,
        'supplyList.supplyActions.remove': FeatureConfig.HIDDEN,
        'supplyList.supplyActions.authorize': FeatureConfig.HIDDEN,
        'supplyList.supplyActions.addBudget': FeatureConfig.ENABLED,
        'supplyList.loadPriceDialog.SelectProvider': FeatureConfig.HIDDEN,
        'orderList.orderActions': FeatureConfig.ENABLED,
        'orderList.orderActions.view': FeatureConfig.HIDDEN,
        'orderList.orderActions.modify': FeatureConfig.HIDDEN,
        'orderList.orderActions.revert': FeatureConfig.ENABLED,
        'orderList.orderActions.delete': FeatureConfig.ENABLED,
        'orderList.orderActions.showDeliveryNote': FeatureConfig.ENABLED,
        'orderList.orderActions.addDeliveryNote': FeatureConfig.ENABLED,
        'orderList.billingCheckbox': FeatureConfig.HIDDEN,
        'attentionListCase.stateChip': FeatureConfig.DISABLED,
        'attentionListCase,deleteBatchBtn': FeatureConfig.HIDDEN,
        'indicators.practicesWithoutAttentions': FeatureConfig.ENABLED,
        'indicators.AttentionsOldAndOmited': FeatureConfig.ENABLED,
        'indicators.AttentionsWithoutBilling': FeatureConfig.DISABLED,
        'indicators.BillingAttentions': FeatureConfig.DISABLED,
        'indicators.SuppliesWithoutOrder': FeatureConfig.ENABLED,
        'indicators.SuppliesNotDelivered': FeatureConfig.ENABLED,
        'indicators.SuppliesWithoutBilling': FeatureConfig.DISABLED,
        'indicators.counterSuppliesNotInformed': FeatureConfig.DISABLED,
        'evolutionsComponent.addEvolutionBtn' : FeatureConfig.HIDDEN,
        'evolutionComponent.setProviderVisibility': FeatureConfig.HIDDEN,
        'evolutionComponent.setFinancierVisibility': FeatureConfig.HIDDEN,
        'evolutionComponent.evolution.actionMenu': FeatureConfig.HIDDEN,
        'evolutionComponent.exportBtn': FeatureConfig.HIDDEN
    },

    tables: {
        'provisionsDetail.header': { hiddenColumns: ['fee'] },
        'provisionsDetail.expanded': { hiddenColumns: ['fee'] },
        'provisionsDetail.collapsed': { hiddenColumns: ['fee'] },
    },

    defaultRoute: '/app/casos/listado',

    routes: {
        // Top-level
        '/login': FeatureConfig.ENABLED,
        '/not-found': FeatureConfig.ENABLED,

        // Área autenticada (BaseLayout)
        '/app': FeatureConfig.ENABLED,
        '/app/principal': FeatureConfig.DISABLED,
        '/app/perfil': FeatureConfig.ENABLED,

        // Admisiones
        '/app/admisiones': FeatureConfig.DISABLED,
        '/app/admisiones/dashboard': FeatureConfig.DISABLED,
        '/app/admisiones/crear': FeatureConfig.DISABLED,
        '/app/admisiones/listado': FeatureConfig.DISABLED,
        '/app/admisiones/archivadas': FeatureConfig.DISABLED,

        // Casos
        '/app/casos': FeatureConfig.ENABLED,
        '/app/casos/listado': FeatureConfig.ENABLED,
        '/app/casos/listado/:id': FeatureConfig.ENABLED,
        '/app/casos/creacion': FeatureConfig.DISABLED,

        // Gestión (schedule)
        '/app/gestion': FeatureConfig.DISABLED,
        '/app/gestion/agenda': FeatureConfig.DISABLED,
        '/app/gestion/agenda/:providerId': FeatureConfig.DISABLED,
        '/app/gestion/consolidacion': FeatureConfig.DISABLED,
        '/app/gestion/control-prestacional': FeatureConfig.ENABLED,
        '/app/gestion/control-prestacional/:id': FeatureConfig.ENABLED,

        // Atenciones
        '/app/atenciones': FeatureConfig.DISABLED,
        '/app/atenciones/listado': FeatureConfig.DISABLED,

        // Tareas
        '/app/tareas': FeatureConfig.DISABLED,
        '/app/tareas/listado': FeatureConfig.DISABLED,

        // Gestión de datos
        '/app/gestion-de-datos': FeatureConfig.DISABLED,
        '/app/gestion-de-datos/obras-sociales': FeatureConfig.DISABLED,
        '/app/gestion-de-datos/clientes': FeatureConfig.DISABLED,
        '/app/gestion-de-datos/prestadores': FeatureConfig.DISABLED,
        '/app/gestion-de-datos/operadores': FeatureConfig.DISABLED,
        '/app/gestion-de-datos/practicas': FeatureConfig.DISABLED,
        '/app/gestion-de-datos/insumos': FeatureConfig.DISABLED,
        '/app/gestion-de-datos/modulos': FeatureConfig.DISABLED,
        '/app/gestion-de-datos/liquidaciones': FeatureConfig.DISABLED,
        '/app/gestion-de-datos/tipos-de-evoluciones': FeatureConfig.DISABLED,
        '/app/gestion-de-datos/convenios': FeatureConfig.DISABLED,
        '/app/gestion-de-datos/convenios/:id': FeatureConfig.DISABLED,
        '/app/gestion-de-datos/forms': FeatureConfig.DISABLED,
        '/app/gestion-de-datos/etiquetas': FeatureConfig.DISABLED,
        '/app/gestion-de-datos/especialidades': FeatureConfig.DISABLED,

        // Prestadores
        '/app/prestadores': FeatureConfig.DISABLED,
        '/app/prestadores/buscar-prestadores': FeatureConfig.DISABLED
    },

    // labels: {
    //     customer: 'Paciente',
    //     seller: 'Profesional',
    //     order: 'Caso'
    // },

    // theme: {
    //     logoUrl: '/assets/logos/logo.svg',
    //     tokens: {
    //         colorPrimary: '#0047AB',
    //         colorSecondary: '#00A36C',
    //         borderRadius: '8px',
    //         fontFamily: 'Montserrat, Arial, sans-serif'
    //     }
    // },

    // api: {
    //     defaults: {
    //         country: 'AR',
    //         currency: 'ARS',
    //         channel: 'webprestadores'
    //     },
    //     operations: {
    //         'orders.search': {
    //             queryParams: {
    //                 includeLegacy: false,
    //                 currency: 'ARS'
    //             }
    //         },
    //         'customers.search': {
    //             headers: {
    //                 'X-Customer-Mode': 'extended'
    //             }
    //         }
    //     }
    // }
};
